import Vue from 'vue';

export class Suntech{

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-suntech/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendConexao(json){
        return Vue.http.post('configuracao-suntech/conexao', json);
    }

    static sendTempos(json){
        return Vue.http.post('configuracao-suntech/times', json);
    }

    static sendTemposAll(json){
        return Vue.http.post('configuracao-suntech/times/all', json);
    }

    static sendNovosParamentos(json){
        return Vue.http.post('configuracao-suntech/novo-parametro', json);
    }

    static sendNovosParamentosAll(json){
        return Vue.http.post('configuracao-suntech/novo-parametro/all', json);
    }

    static sendServicos(json){
        return Vue.http.post('configuracao-suntech/servicos', json);
    }

    static sendServicosAll(json){
        return Vue.http.post('configuracao-suntech/servicos/all', json);
    }

    static sendTensao(json){
        return Vue.http.post('configuracao-suntech/tensao', json);
    }

    static sendAcelerometro(json){
        return Vue.http.post('configuracao-suntech/acelerometro', json);
    }

    static sendEventos(json){
        return Vue.http.post('configuracao-suntech/eventos', json);
    }

    static sendPadraoDirecao(json){
        return Vue.http.post('configuracao-suntech/padrao-direcao', json);
    }

    static solicitarIbutton(idRastreador){
        return Vue.http.get('api/v1/configuracao-suntech/' + idRastreador + '/ibutton');
    }

    static removeIbutton(idRastreador){
        return Vue.http.delete('api/v1/configuracao-suntech/' + idRastreador + '/ibutton');
    }

    static cadastrarIbutton(idRastreador, json){
        return Vue.http.post('api/v1/configuracao-suntech/' + idRastreador + '/ibutton', json);
    }

}
